import PropTypes from 'prop-types';
import { getNumberWithDelimeter } from '../../../../utils/helpers';
import colors from '../../../../scss/colors';
import classes from './TableBasicLabel.module.scss';

export default function TableBasicLabel({
  withForceBrake = '100%',
  notNumber = false,
  text = '',
  fontSize = '16px',
  fontWeight = '400',
  lineHeight = '19px',
  fontColor = colors.NAVY_BLUE,
  isTruncate = false,
  textAlign = 'center',
  padding = '0',
  isEdit = false
}) {
  return (
    <p
      className={isTruncate ? classes.truncate : undefined}
      style={{ fontSize, fontWeight, lineHeight, color: fontColor, width: withForceBrake, textAlign, padding }}
    >
      {Number.isNaN(text) || notNumber ? text : getNumberWithDelimeter(text, isEdit)}
    </p>
  );
}

TableBasicLabel.propTypes = {
  withForceBrake: PropTypes.string,
  notNumber: PropTypes.bool,
  text: PropTypes.any,
  fontSize: PropTypes.string,
  fontWeight: PropTypes.any,
  lineHeight: PropTypes.string,
  fontColor: PropTypes.string,
  isTruncate: PropTypes.bool,
  textAlign: PropTypes.string,
  padding: PropTypes.string,
  isEdit: PropTypes.bool
};
